import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, RowNode } from 'ag-grid-community';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ProjectService } from 'src/app/services/project.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { combineLatest, of, Subject } from 'rxjs';
import { ConfigurationLockService } from 'src/app/services/configuration-lock.service';

@Component({
  selector: 'app-add-material',
  templateUrl: './add-material.component.html',
  styleUrls: ['./add-material.component.css']
})
export class AddMaterialComponent implements ICellRendererAngularComp {
  public gridApi: any;
  public params: any;
  isAddVisible: any;
  projectId: any;
  businessAreaId: any;
  businessLineId: any;
  allUserList: any;
  userInOrg: any;
  projectSubmitterId: any;
  isEditable: boolean;
  combinedSub: any;
  
  //lock/unlock page variables
  roleBasedEditable: boolean = false;
  isLocked: boolean = false;
  lockedByUserId: string | null = null;
  lockedByUserName: string | null = null;
  lockStatusInfo: any = null;
  configSub: any;
  lockStatusSub: any;
  configurationId: any;
  constructor(
    private sharedService: SharedServiceService,
    private projectService: ProjectService,
    private userService: UserInfoService,
    private configurationLockService: ConfigurationLockService,
    private localStorageService: LocalStorageService,
  ) { }


  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  // get called on load of the component;
  agInit(params: ICellRendererParams) {
    this.params = params;
    this.gridApi = params.api;
    this.projectId = this.localStorageService.get("projectId");

    if (this.projectId != null) {
      this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {
          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              // this.showGrid = true
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
               if (this.userInOrg != undefined) {
                
                 // this.setupLockAndConfigSubscription();
                 
                // Subscribe to configurationId changes
                this.configSub = this.sharedService.configurationId
                .pipe(
                  filter(configId => !!configId),
                  distinctUntilChanged()
                )
                .subscribe(configId => {
                  this.configurationId = configId;
                  // Fetch lock status for the new configId (AppComponent should do this, but safe here)
                  // this.configurationLockService.fetchLockStatus(configId, ...); // Only if needed
                  // Do NOT call loadData() here!
                });

              // Subscribe to lockStatus changes
              this.lockStatusSub = this.configurationLockService.lockStatus$
                .pipe(
                  filter(lockStatus => lockStatus !== null)
                )
                .subscribe(lockStatus => {
                  // Only call loadData if lockStatus is for the current configId
                  if (lockStatus.ConfigId == this.configurationId) {
                    this.lockStatusInfo = lockStatus;
                    this.isEditable = lockStatus.isLocked && lockStatus.lockedByUserId === this.userInOrg?.UserId
                      ? true
                      : false;
                   
                  }
                });

                }
             })
            }
          })
        }
      });
    } else {
      this.businessAreaId = this.businessLineId = 0;
    }
  }
  
  addData(params: any) {
    let gmk, plant, configId;

    gmk = params.node.allLeafChildren[0].data.GMKGroup;
    plant = params.node.allLeafChildren[0].data.Plant;
    configId = params.node.allLeafChildren[0].data.ConfigurationId;

    let addObject = {
      IsManual: true,
      IsEditable: true,
      KMAT: "Please Select",
      KMATId: 0,
      KMATText: "",
      VBLO: "Please Select",
      VBLOId: 0,
      VBLODescription: "",
      EcoId: "",
      GMKGroup: gmk,
      Plant: plant,
      ProcurementType: "",
      Assembly: "",
      Component: "Please Select",
      ComponentDescription: "Add Description",
      BKsPerPiece: 0,
      Material: 0,
      MaterialDescription: "Add Description",
      MaterialNo: 0,
      EQId: 0, 
      KMATVBLOId: 0,
      ConfigurationId: configId,
      ReferencceScenario: {
        ScenarioTitle: "",
        EQId: 0,
        MEKsPerPiece: 0,
        Quantity: 0,
        Weight: 0,
        MEKPerSystem: 0,
      },
      TargetScenario: {
        ScenarioTitle: "",
        TargetCostMEK: {
          EQId: 0,
          PerPiece: 0,
          Quantity: 0,
          Weight: 0,
          PerSystem: 0,
          DeltaTCVsRefMEK: 0,
        },
        ForecastMEK: {
          EQId: 0,
          PerPiece: 0,
          PerSystem: 0,
          DeltaFCVsRefMEK: 0,
          ActualsMEK: 0,
          DeltaTCVsACT: 0,
        }
      }
    };

    this.updateFieldValues(params.node, addObject);

    this.sharedService.getEqAddedRow(addObject, 0);

    this.gridApi.applyTransaction({
      add: [addObject], addIndex: 0
    })
  }

  updateFieldValues(rowNode: RowNode, addObject) {
    if (rowNode.field != 'Material' && rowNode.field != 'Material Description') {
      let field = rowNode.field;
      addObject[field] = rowNode.key;

      let data = rowNode.allLeafChildren[0].data;
       if (field == "KMAT" || field == "KMATText") {
        addObject["KMAT"] = data.KMAT;
        addObject["KMATText"] = data.KMATText;
      }
      if (field == "VBLO" || field == "VBLODescription") {
        addObject["VBLO"] = data.VBLO
        addObject["VBLODescription"] = data.VBLODescription;
        addObject["KMATVBLOId"] = data.KMATVBLOId;
        addObject["KMATId"] = data.KMATId;
        addObject["VBLOId"] = data.VBLOId;
      }

      if (field == "Component" || field == "ComponentDescription") {
        addObject["Component"] = data.Component;
        addObject["ComponentDescription"] = data.ComponentDescription;
      }
    }
    if (rowNode.parent.hasOwnProperty("parent"))
      this.updateFieldValues(rowNode.parent, addObject);
  }

}
